import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Button, IconButton } from '@mui/material';
// components
import Iconify from '../../components/Iconify';

export default function SettingFullscreen() {
	const [fullscreen, setFullscreen] = useState(false);

	const toggleFullScreen = () => {
		if (!document.fullscreenElement) {
			document.documentElement.requestFullscreen();
			setFullscreen(true);
		} else if (document.exitFullscreen) {
			document.exitFullscreen();
			setFullscreen(false);
		}
	};

	return (
		<IconButton onClick={toggleFullScreen}>
			<Iconify icon="ic:round-fullscreen" width={25} height={25} />
		</IconButton>
	);
}
